<!--全局变量-->
<script>
    // 线上接口地址
    const rootUrl = "https://www.lingfenxiang.com/api/";

    // 本地测试地址
    // const rootUrl = "/apis";

    export default {
        rootUrl
    }
</script>